<template>
  <!-- name: '选项卡切换组件' -->
  <ul class="selectTabBox">
    <li v-for="(item, index) in selectTabList" :key="index" :class="item === curSelectTab ? 'actClass' : ''"
      @click="$emit('selectTab', item)">
      <span>{{ item }} <span class="lineBox"></span></span>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    selectTabList: {
      type: Array,
      default: () => [],
      required: true,
    },
    curSelectTab: {
      type: String,
      default: "",
      required: true,
    },
  },
  components: {},
  data() {
    return {};
  },
  created() { },
  methods: {},
};
</script>

<style lang="scss" scoped>
.selectTabBox {
  width: 100%;
  height: 88px;
  border-top: 1px #ededed solid;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #fff;
  padding: 0px 40px;

  li {
    padding: 0px 15px;
    height: 100%;
    font-size: 30px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #999999;

    text-align: center;

    span {
      width: auto;
      height: 100%;
      display: flex;
      justify-content: center;
      flex-flow: column;
      align-items: center;
      line-height: 88px;
    }

    .lineBox {
      width: 100%;
      height: 6px;
      background: #fe66a6;
      border-radius: 3px;
      display: none;
      max-width: 56px;
      margin-top: -10px;
    }

    &.actClass {
      font-weight: 600;
      color: #333333;

      .lineBox {
        display: block;
      }
    }
  }
}
</style>
